/** Vertical jitter band for contract distribution scatter (Y is not contract value). */
export const SCATTER_JITTER_MAX = 500;
